import React from "react";
import { graphql, useStaticQuery } from "gatsby";

import { useTheme } from "../../context/ThemeContext";

import { useBreakpoint } from "../../hooks/useBreakpoint";

import { Link } from "../../utils/customLink";
import { addTrailingSlash } from "../../utils/commonFunctions";

import ArticleCard from "../../components/cards/articleCard";
import { ConditionalSwiper } from "../../components/shared/conditionalSwiper";

import ArrowRightIcon from "../../images/icons/arrow-right-icon.inline.svg";

const FocusArticles = ({ blogPosts }) => {
  const { placeholderBlogPosts } = useStaticQuery(graphql`
    {
      placeholderBlogPosts: allWpPost(limit: 5, sort: { modified: DESC }) {
        nodes {
          ...miniBlogPostsFragment
        }
      }
    }
  `);

  const { planetDomain } = useTheme();

  const blogsite = [planetDomain, "/blog"].join("");

  const articleHeading = "Read up on our articles";

  const postCollection = placeholderBlogPosts?.nodes ?? blogPosts ?? [];

  const gviArticles = postCollection
    ? postCollection.slice(0, 4).map((blogArticle, idx) => {
        return {
          id: idx,
          img: blogArticle?.featuredImage?.node?.localFile?.extension
            ? blogArticle?.featuredImage?.node?.localFile
            : null,
          sourceUrl: blogArticle?.featuredImage?.node?.sourceUrl,
          title: blogArticle.title,
          author: blogArticle?.author?.node?.firstName
            ? [
                blogArticle?.author?.node?.firstName,
                blogArticle?.author?.node?.lastName
              ].join(" ")
            : blogArticle?.author?.node?.name,
          uri: addTrailingSlash([blogsite, blogArticle.slug].join("/")),
          postedDate: blogArticle.date
        };
      })
    : [];

  const viewMoreText = "View more articles";
  const viewMoreLink = addTrailingSlash(blogsite);
  const breakpoint = useBreakpoint();

  return (
    <>
      {gviArticles && gviArticles.length > 0 && (
        <section className="relative flex items-center justify-center px-4 md:px-0 bg-generic-bg planet:gvi-light-gray-bg sm:pt-6 sm:pb-4 ">
          <div className="container w-full pt-9 md:w-4/5 sm:py-6 md:pt-12 md:pb-[8rem] sm:pb-8">
            <div className="text-left">
              <h1 className="leading-[2.875rem] not-italic font-light planet:text-white text-generic-text lato-300-latin">
                {articleHeading}
              </h1>
            </div>
            <div className="pt-12 pb-6">
              <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
                <ConditionalSwiper
                  condition={breakpoint === "xs"}
                  slidesPerView={1.25}
                  spaceBetween={10}
                  centeredSlides={false}
                  className="w-full h-full"
                >
                  {gviArticles &&
                    gviArticles.length > 0 &&
                    gviArticles.map((article, idx) => (
                      <div className="flex flex-col rounded-md" key={idx}>
                        <Link to={article.uri}>
                          <ArticleCard article={article} />
                        </Link>
                      </div>
                    ))}
                </ConditionalSwiper>
              </div>
            </div>
            <div className="flex items-center justify-start pb-8 sm:justify-end sm:pb-0">
              <div>
                <Link
                  className="flex flex-row items-center justify-center px-4 link-white-underline !text-generic-text planet:!text-white"
                  to={viewMoreLink}
                >
                  {viewMoreText}
                  <ArrowRightIcon className="ml-4 stroke-black-lighter planet:stroke-white" />
                </Link>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default FocusArticles;
